/* ============================================================================
   Yuvakart — "Help Me Choose" tab: gold vertical restyle + draggable
   Companion to yuvakart-help-me-choose.js. Transforms the existing .ykq-tab
   button into the Japam-style vertical gold tab and makes it draggable
   (vertical, touch + mouse). A plain tap still opens the Kundali quiz.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__ykHelpTabEnhanced) return;
  window.__ykHelpTabEnhanced = 1;

  var GOLD = '#C49A2A', GOLD2 = '#F0D67A', DARK = '#1A0800';

  /* ---- styles (｜important so they win over the existing quiz CSS) ---- */
  var css = [
    '.ykq-tab{position:fixed!important;right:0!important;top:42%;',
    'transform:translateY(-50%);z-index:21!important;display:flex!important;',
    'flex-direction:row!important;align-items:center!important;cursor:grab;',
    'border:none!important;background:none!important;padding:0!important;',
    'margin:0!important;width:auto!important;height:auto!important;',
    'min-width:0!important;box-shadow:none!important;font-size:initial!important;',
    'letter-spacing:normal!important;writing-mode:horizontal-tb!important;',
    '-webkit-tap-highlight-color:transparent;touch-action:none;user-select:none;',
    'transition:transform .25s cubic-bezier(.16,1,.3,1);}',
    '.ykq-tab.ykq-tab--drag{cursor:grabbing;transition:none;}',
    '.ykq-tab .ykq-edge{width:3px;height:90px;background:', GOLD, ';',
    'border-radius:3px 0 0 3px;opacity:.7;flex:0 0 auto;}',
    '.ykq-tab .ykq-body{display:flex;flex-direction:column;align-items:center;',
    'gap:7px;padding:14px 0;min-height:105px;background:', DARK, ';',
    'border:1px solid ', GOLD, ';border-right:none;border-radius:10px 0 0 10px;',
    'box-shadow:-4px 0 20px rgba(196,154,42,.12);}',
    '.ykq-tab .ykq-ic{width:20px;height:20px;flex:0 0 auto;}',
    '.ykq-tab .ykq-txt{display:flex;flex-direction:column;align-items:center;',
    'gap:4px;transform:rotate(-90deg) translateX(-2px);white-space:nowrap;}',
    '.ykq-tab .ykq-h{font-size:9px;font-weight:400;letter-spacing:.12em;',
    'line-height:1;text-transform:uppercase;color:', GOLD, ';}',
    '.ykq-tab .ykq-c{font-size:10px;font-weight:700;letter-spacing:.16em;',
    'line-height:1;text-transform:uppercase;color:', GOLD2, ';}'
  ].join('');
  var st = document.createElement('style');
  st.setAttribute('data-ykq-tab', '1');
  st.textContent = css;
  document.head.appendChild(st);

  var MARKUP =
    '<span class="ykq-edge"></span>' +
    '<span class="ykq-body">' +
      '<svg class="ykq-ic" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M10 2C10 2 5 6.5 5 10.5C5 13.538 7.238 16 10 16C12.762 16 15 13.538 15 10.5C15 6.5 10 2 10 2Z" stroke="' + GOLD + '" stroke-width="1.2" stroke-linejoin="round" fill="none"></path>' +
        '<circle cx="10" cy="10.5" r="2" fill="' + GOLD + '" opacity="0.5"></circle>' +
        '<circle cx="10" cy="10.5" r="0.8" fill="' + GOLD + '"></circle>' +
      '</svg>' +
      '<span class="ykq-txt"><span class="ykq-h">Help Me</span><span class="ykq-c">Choose</span></span>' +
    '</span>';

  var MARGIN = 8, THRESH = 6, KEY = 'ykqTabTop';

  function clamp(px, el) {
    var max = window.innerHeight - el.offsetHeight - MARGIN;
    return Math.max(MARGIN, Math.min(px, max));
  }

  function enhance(tab) {
    if (tab.__ykq) return;
    tab.__ykq = 1;
    tab.innerHTML = MARKUP;                 // keeps the <button> + its existing onclick (opens quiz)
    tab.setAttribute('aria-label', 'Help me choose');

    // switch from % centering to a pixel top so dragging is stable
    var saved = null;
    try { saved = parseFloat(localStorage.getItem(KEY)); } catch (e) {}
    var top = (saved != null && !isNaN(saved)) ? saved : (window.innerHeight * 0.42 - tab.offsetHeight / 2);
    tab.style.top = clamp(top, tab) + 'px';
    tab.style.transform = 'none';

    var startY = 0, startTop = 0, dragging = false, moved = false;

    tab.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false;
      startY = e.clientY;
      startTop = parseFloat(tab.style.top) || tab.getBoundingClientRect().top;
      try { tab.setPointerCapture(e.pointerId); } catch (_) {}
      tab.classList.add('ykq-tab--drag');
    });
    tab.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dy = e.clientY - startY;
      if (Math.abs(dy) > THRESH) moved = true;
      if (moved) { e.preventDefault(); tab.style.top = clamp(startTop + dy, tab) + 'px'; }
    });
    function end(e) {
      if (!dragging) return;
      dragging = false;
      tab.classList.remove('ykq-tab--drag');
      try { tab.releasePointerCapture(e.pointerId); } catch (_) {}
      if (moved) { try { localStorage.setItem(KEY, parseFloat(tab.style.top)); } catch (_) {} }
    }
    tab.addEventListener('pointerup', end);
    tab.addEventListener('pointercancel', end);
    // if the user dragged, swallow the click so the quiz doesn't open
    tab.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopImmediatePropagation(); moved = false; }
    }, true);

    window.addEventListener('resize', function () {
      tab.style.top = clamp(parseFloat(tab.style.top) || 0, tab) + 'px';
    });
  }

  function scan() {
    var tab = document.querySelector('.ykq-tab');
    if (tab) enhance(tab);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  // the quiz builds .ykq-tab on boot; watch briefly in case it appears after us
  if (window.MutationObserver) {
    var mo = new MutationObserver(scan);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (_) {} }, 8000);
  }
})();
